<template>
  <div class="editPage">
    <qx-card title="事故登记">
      <BaseForm ref="baseForm" />
      <RegistrationForm ref="registrationForm" />
      <LossForm ref="lossForm" />
      <MaintainForm ref="maintainForm" />
      <ClaimForm ref="claimForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import RegistrationForm from './registration';
import LossForm from './loss';
import MaintainForm from './maintain';
import ClaimForm from './claim';
import SubBtnBox from 'components/subBtnBox';
import {
  getVehicleAccidentInfo,
  doSaveVehicleAccidentInfo,
} from 'api/car';
import {
  getEnumList,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    RegistrationForm,
    LossForm,
    MaintainForm,
    ClaimForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/car/maintain/accident/edit',
      formComponents: [
        'baseForm',
        'registrationForm',
        'lossForm',
        'maintainForm',
        'claimForm',
      ],

      // 需要对比的参数
      compareParams: {
        plateNumber: '',
        isClosingCase: '',

        reportTime: '',
        accidentTime: '',
        accidentPassing: '',
        accidentRemark: '',
        accidentResponsibility: '',
        vehicleAccidentPicFileList: [],
        vehicleAccidentSurePicFileList: [],

        isVehicleDamage: '',
        isOtherAccident: '',
        isGoodsDamage: '',
        isRoadDamage: '',
        isWounding: '',
        vehicleAccidentLossAssessmentFileIds: '',

        vehicleAccidentRepairPicFileList: [],
        vehicleAccidentRepairCompPicFileList: [],
      },
    };
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
      };
    },
    editParams () {
      return this.$route.query.id ? 1 : 0;
    },
  },
  methods: {
    detailApi: getVehicleAccidentInfo,
    editApi: doSaveVehicleAccidentInfo,
    // 处理对比参数
    adjustCompareParams (compareParams) {
      compareParams.vehicleAccidentPicFileIds = '';
      compareParams.vehicleAccidentSurePicFileIds = '';
      compareParams.vehicleAccidentRepairPicFileIds = '';
      compareParams.vehicleAccidentRepairCompPicFileIds = '';

      if (compareParams.vehicleAccidentPicFileList && compareParams.vehicleAccidentPicFileList.length) {
        const vehicleAccidentPicFileList = [];
        for (let item of compareParams.vehicleAccidentPicFileList) {
          vehicleAccidentPicFileList.push(item.fileId);
        }
        compareParams.vehicleAccidentPicFileIds = vehicleAccidentPicFileList.join(',');
      }

      if (compareParams.vehicleAccidentSurePicFileList && compareParams.vehicleAccidentSurePicFileList.length) {
        const vehicleAccidentSurePicFileList = [];
        for (let item of compareParams.vehicleAccidentSurePicFileList) {
          vehicleAccidentSurePicFileList.push(item.fileId);
        }
        compareParams.vehicleAccidentSurePicFileIds = vehicleAccidentSurePicFileList.join(',');
      }

      if (compareParams.vehicleAccidentRepairPicFileList && compareParams.vehicleAccidentRepairPicFileList.length) {
        const vehicleAccidentRepairPicFileList = [];
        for (let item of compareParams.vehicleAccidentRepairPicFileList) {
          vehicleAccidentRepairPicFileList.push(item.fileId);
        }
        compareParams.vehicleAccidentRepairPicFileIds = vehicleAccidentRepairPicFileList.join(',');
      }

      if (compareParams.vehicleAccidentRepairCompPicFileList && compareParams.vehicleAccidentRepairCompPicFileList.length) {
        const vehicleAccidentRepairCompPicFileList = [];
        for (let item of compareParams.vehicleAccidentRepairCompPicFileList) {
          vehicleAccidentRepairCompPicFileList.push(item.fileId);
        }
        compareParams.vehicleAccidentRepairCompPicFileIds = vehicleAccidentRepairCompPicFileList.join(',');
      }
    },
    async init (data = {}) {
      this.$refs.baseForm.getVehicleInsuranceInfo();

    },
  },
  async mounted () {
    const enumsList = await getEnumList({
      codeType: 'SHARE_FLG,RESPONSIBILITY_ATTRIBUTION,ACCIDENT_TYPE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    const shareFlgOptions = [
      { label: '请选择', value: '-1' },
      ...safeEnum(0),
    ];
    const accidentResponsibilityOptions = [
      ...safeEnum(1),
    ];
    const accidentTypeOptions = [
      ...safeEnum(2),
    ];
    if (this.$refs.registrationForm) {
      this.$refs.registrationForm.setList([accidentResponsibilityOptions, accidentTypeOptions]);
    }
    if (this.$refs.lossForm) {
      this.$refs.lossForm.setList(shareFlgOptions);
    }
    if (this.$refs.maintainForm) {
      this.$refs.maintainForm.setList(shareFlgOptions);
    }
    if (this.$refs.claimForm) {
      this.$refs.claimForm.setList(shareFlgOptions);
    }
    this.getData();
  },
};
</script>

<style>
</style>
